import { Box, Typography } from '@mui/material'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn'

/**
 * TEMPORARY MIGRATION CODE - REMOVE WITH THE REST OF LegacyNativeVersionGate.
 *
 * Full-screen. Deliberately mirrors the wording of the native
 * ForceUpdateActivity / ForceUpdateViewController screens so a user cannot tell
 * which of the two gated them.
 */
const UpdateRequiredScreen = ({ storeUrl, t }) => {
  const title = t?.['Update required'] || 'Update required'
  const messageKey = 'An update to a newer version of the app is required to continue. Please update to keep using it.'
  const message = t?.[messageKey] || messageKey
  const action = t?.['Update Now'] || 'Update Now'

  return (
    <Box sx={styles.root}>
      <Box sx={styles.content}>
        <Typography sx={styles.title}>{title}</Typography>
        <Typography sx={styles.message}>{message}</Typography>
        <OfoqThemeBtn
          name={action}
          onClick={() => window.open(storeUrl, '_system')}
        />
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    position: 'fixed',
    inset: 0,
    // Above every dialog, drawer and snackbar in the app so nothing can be
    // interacted with behind it.
    zIndex: 2000,
    backgroundColor: 'background.paper',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '16px',
    maxWidth: '420px',
  },
  title: {
    fontSize: '20px',
    fontFamily: 'Avenir-bold',
    color: 'text.primary',
  },
  message: {
    fontSize: '15px',
    color: 'text.secondary',
  },
}

export default UpdateRequiredScreen
